export const CalendarConstants = {
  FETCH_CALENDARS_BY_CHRONICLE_REQUEST: 'FETCH_CALENDARS_CHRONICLE_REQUEST',
  FETCH_CALENDARS_BY_CHRONICLE_SUCCESS: 'FETCH_CALENDARS_CHRONICLE_SUCCESS',
  FETCH_CALENDARS_BY_CHRONICLE_FAILURE: 'FETCH_CALENDARS_CHRONICLE_FAILURE',

  FETCH_CALENDARS_BY_WORLD_REQUEST: 'FETCH_CALENDARS_WORLD_REQUEST',
  FETCH_CALENDARS_BY_WORLD_SUCCESS: 'FETCH_CALENDARS_WORLD_SUCCESS',
  FETCH_CALENDARS_BY_WORLD_FAILURE: 'FETCH_CALENDARS_WORLD_FAILURE',

  FETCH_BY_ID_REQUEST: 'FETCH_CALENDAR_BY_ID_REQUEST',
  FETCH_BY_ID_SUCCESS: 'FETCH_CALENDAR_BY_ID_SUCCESS',
  FETCH_BY_ID_FAILURE: 'FETCH_CALENDAR_BY_ID_FAILURE',

  CREATE_NEW_REQUEST: 'CREATE_NEW_CALENDAR_REQUEST',
  CREATE_NEW_SUCCESS: 'CREATE_NEW_CALENDAR_SUCCESS',
  CREATE_NEW_FAILURE: 'CREATE_NEW_CALENDAR_FAILURE',

  UPDATE_REQUEST: 'UPDATE_CALENDAR_REQUEST',
  UPDATE_SUCCESS: 'UPDATE_CALENDAR_SUCCESS',
  UPDATE_FAILURE: 'UPDATE_CALENDAR_FAILURE',

  DELETE_REQUEST: 'DELETE_CALENDAR_REQUEST',
  DELETE_SUCCESS: 'DELETE_CALENDAR_SUCCESS',
  DELETE_FAILURE: 'DELETE_CALENDAR_FAILURE',
};
